import React from 'react';
import {
  Building2,
  Truck,
  Target,
  Package,
  BadgeDollarSign,
  TruckIcon,
  CreditCard,
  Globe,
  ArrowDown,
} from 'lucide-react';
import Card from '../ui/Card';

const ValueProposition = () => {
  const valuePoints = [
    {
      id: 1,
      icon: Building2,
      title: 'Ease of Material Sourcing',
      description: 'All key construction materials under one roof—no vendor hassles.',
      color: 'text-secondary-600',
      bgColor: 'bg-secondary-50',
    },
    {
      id: 2,
      icon: BadgeDollarSign,
      title: 'Best Price & Quality',
      description: 'Competitive pricing on genuine products from approved manufacturers.',
      color: 'text-secondary-600',
      bgColor: 'bg-secondary-50',
    },
    {
      id: 3,
      icon: TruckIcon,
      title: 'Frictionless Logistics',
      description: 'Door-to-site delivery via our established transporter network.',
      color: 'text-secondary-600',
      bgColor: 'bg-secondary-50',
    },
    {
      id: 4,
      icon: CreditCard,
      title: 'Flexible Financing',
      description: 'Credit facilities and tailored payment terms to ease working-capital stress.',
      color: 'text-secondary-600',
      bgColor: 'bg-secondary-50',
    },
    {
      id: 5,
      icon: Globe,
      title: 'Digitization',
      description: 'Real-time visibility of your order through our tech platform.',
      color: 'text-secondary-600',
      bgColor: 'bg-secondary-50',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-primary-600 to-secondary-600 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M0 0h40v40H0V0zm40 40h40v40H40V40z' fill-opacity='0.1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}/>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            OUR{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-orange-400">
              VALUE PROPOSITION
            </span>
          </h2>
          <p className="text-xl text-gray-200">
            Bringing Efficiency to Construction
          </p>
        </div>

        {/* Flow Diagram */}
      

        {/* Value Points Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {valuePoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <Card
                key={point.id}
                className="bg-white text-gray-900 hover:shadow-xl transition-all duration-300 animate-slide-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="text-center space-y-3">
                  <div className={`w-14 h-14 ${point.bgColor} rounded-lg mx-auto flex items-center justify-center`}>
                    <Icon className={`w-7 h-7 ${point.color}`} />
                  </div>
                  <h3 className="text-base font-bold text-gray-900">
                    {point.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {point.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
